import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getCartData } from '../../redux/actions/cartActions'
import { getProfile } from '../../redux/actions/profileActions'
import { getUserOrders } from '../../redux/actions/orderActions'
import Filters from './Filters'
import Products from './Products'
import Loading from '../utils/Loading'
import MobileSearchBar from '../layout/MobileSearchBar'

export class Shop extends Component {

  componentDidUpdate=(prevProps)=>{
    const { uid } = this.props.user.user
    if(prevProps.user !== this.props.user){
      this.props.getCartData(uid)   
      this.props.getProfile(uid) 
      this.props.getUserOrders()      
    }
  }
  
  componentDidMount=(prevProps)=>{
    const { uid } = this.props.user.user
    if(uid !== undefined){
      this.props.getUserOrders()      
      this.props.getCartData(uid)   
      this.props.getProfile(uid)       
    }
  }

  render() {
    const { products } = this.props.products
    return (
      <div className="shop-page">
        <MobileSearchBar />
        <Filters />
       {products.length === 0 ? <Loading /> :
        <Products products={products} />}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  products: state.products,
  user: state.user
})

export default connect(mapStateToProps, { getCartData, getProfile, getUserOrders })(Shop)
